// removed by extract-text-webpack-plugin
module.exports = {"formError":"_2ydn6k-NPk2VncEQEFZeie","formErrorIcon":"TnVcmmtcxz8zjDKXjdpdC"};


/*****************
 ** WEBPACK FOOTER
 ** ./client/form/FormError.css
 ** module id = 791
 ** module chunks = 0 1
 **/